import React from 'react'
import Color from '../../../components/Field.Color'

import Card from './Card'
import Group from './Group'
import Label from './Group.Label'
import Item from './Group.Item'

function Component(
    {
        fieldLayout,
        disabled,

        select,
        onChange,
    }
)
{
    return (
        <Card title="ข้อมูล" >
            <Group>
                <Item>
                    <Label> </Label>
                    <Group group>
                        <Item>
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="พื้นหลัง"
                                name="detail.bgColor"
                                alpha={false}
                                value={select('detail.bgColor')}
                                onChange={onChange}
                            />
                            
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="หัวข้อ"
                                name="detail.title.color"
                                alpha={false}
                                value={select('detail.title.color')}
                                onChange={onChange}
                            />
                        </Item>
                    </Group>
                </Item>
                <Item>
                    <Label>รายละเอียด</Label>
                    <Group group>
                        <Item>
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="หัวข้อ"
                                name="detail.feature.primary.color"
                                alpha={false}
                                value={select('detail.feature.primary.color')}
                                onChange={onChange}
                            />

                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="ข้อความ"
                                name="detail.feature.secondary.color"
                                alpha={false}
                                value={select('detail.feature.secondary.color')}
                                onChange={onChange}
                            />
                        </Item>
                    </Group>
                </Item>
            </Group>
        </Card>
    )
}

export default Component